const locale = {
  placeholder: 'Цаг сонгох',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/mn_MN.js